<template>
  <tableView v-if="usersData.length > 0" :users="usersData" :loading="loading" @user-api-call="fetchUsers" />
  <div v-else-if="timeoutMessage != ''" class="no-asset-div timeout">
        <div class="text-center">
          {{ timeoutMessage }}
          <v-icon flat @click="fetchUsers()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
        </div>
      </div>
</template>

<script>
import tableView from "@/components/layout/Users/table.vue";
import api from "@/axiosInterceptor"; // Ensure this is correctly set up

export default {
  components: { tableView },
  name: "index",
  data() {
    return {
      usersData: [],
      isLoading: false,
      timeoutMessage: "",
    };
  },
  methods: {
    async fetchUsers() {
      this.isLoading = true;
      this.timeoutMessage = "";
      api
        .get("public/api/admin/users")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.usersData = response.data.data;
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching assets";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.fetchUsers();
  },
};
</script>
